import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.081}
      d="M22.398 18.954a1.616 1.616 0 0 1-1.36 1.836L7.653 22.784a1.616 1.616 0 0 0 1.36-1.836l-.119-.8 13.385-1.993z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.081}
      d="m18.927 14.842.555 3.73-10.588 1.576.12.8a1.6 1.6 0 0 1-.3 1.2 1.611 1.611 0 0 1-2.26.337 1.6 1.6 0 0 1-.637-1.061L3.63 6.744a3.62 3.62 0 0 0-2.9-3.022S12 2 14 2s3.188 1.169 3.414 2.69l.976 6.55"
    />
    <path
      strokeLinecap="round"
      d="M13.5 7C13.167 5.833 12 4 10 5.5 7.728 7.204 10 9 13 9c1.581 0 1.667 2.5 1 3"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      strokeLinecap="round"
      d="M10 8.5c-.853.407-1.803 1.599-.78 3.11C10.5 13.5 14.5 12 14 14.5s-3.5 1.5-4 0"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const LegalAdvisorIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
